"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M44.0323 15.1091C43.6618 14.9285 43.235 14.9017 42.8448 15.0343C42.4546 15.167 42.1326 15.4485 41.949 15.8174L40.574 18.6924C39.2181 14.897 36.6754 11.6394 33.3227 9.40262C29.97 7.16583 25.9858 6.06889 21.9607 6.2744C17.9356 6.47991 14.0838 7.97694 10.9763 10.5436C7.86888 13.1102 5.67116 16.6098 4.70895 20.5236C3.74673 24.4374 4.07125 28.5571 5.63438 32.272C7.19752 35.9869 9.91607 39.0993 13.3871 41.1477C16.858 43.1961 20.8967 44.0716 24.9044 43.6444C28.912 43.2171 32.6753 41.5099 35.6365 38.7758C35.902 38.4897 36.0508 38.1147 36.0537 37.7244C36.0566 37.3341 35.9134 36.9569 35.6521 36.667C35.3909 36.377 35.0306 36.1953 34.6422 36.1576C34.2537 36.1199 33.8652 36.229 33.5531 36.4633C31.0848 38.7519 27.9425 40.181 24.5953 40.5373C21.2481 40.8935 17.8754 40.1579 14.9806 38.4401C12.0858 36.7223 9.8241 34.1145 8.53302 31.0058C7.24193 27.8971 6.9907 24.4543 7.81682 21.1912C8.64293 17.928 10.5021 15.0195 13.1169 12.8996C15.7316 10.7798 18.9618 9.56228 22.3252 9.42885C25.6887 9.29543 29.0051 10.2532 31.7796 12.1593C34.5541 14.0653 36.6378 16.8175 37.7198 20.0049L34.5115 18.2549C34.1546 18.0609 33.7357 18.0155 33.3456 18.1286C32.9555 18.2418 32.6258 18.5043 32.4281 18.8591C32.2465 19.2205 32.2101 19.6377 32.3263 20.0251C32.4425 20.4125 32.7026 20.7407 33.0531 20.9424L39.4698 24.4633C39.6998 24.5885 39.9579 24.653 40.2198 24.6508C40.3719 24.6711 40.526 24.6711 40.6781 24.6508C40.8827 24.5888 41.072 24.4845 41.2335 24.3445C41.395 24.2045 41.5252 24.032 41.6156 23.8383L44.8448 17.2758C44.9445 17.082 45.0025 16.8695 45.0151 16.6519C45.0278 16.4344 44.9948 16.2166 44.9183 16.0125C44.8418 15.8085 44.7234 15.6227 44.5708 15.4671C44.4183 15.3115 44.2348 15.1896 44.0323 15.1091Z",
    fill: fill
  }));
};

exports["default"] = _default;